import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class GoToDownloadButton extends Component {
  handleButtonClick = () => {
    window.location.hash = 'download'
  }

  render() {
    return (
      <button className="h2 w-100 w-60-ns h3-ns br2 b-pink bg-pink white b f3-ns tracked pointer" onClick={this.handleButtonClick}>
        <FormattedMessage id="titlePage.appButton" />
      </button>
    )
  }
}

export default GoToDownloadButton



// WEBPACK FOOTER //
// ./src/components/GoToDownloadButton.js